export const apiUrl = process.env.REACT_APP_REST_API_SERVICE_ENDPOINT_URL;
